"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const thread_1 = require("../../../app/dist/thread");
exports.toolDef = {
    name: 'loom_rename_thread',
    description: "Rename a thread's folder slug. The thread is identified by its stable th_ ULID (thread_ulid); its identity and all its docs are untouched, so depends_on edges and every backlink survive. (Legacy thread-prefixed idea/design filenames are flattened to idea.md/design.md so the rename holds pre-migration.) Use this tool — do not rename thread folders directly.",
    inputSchema: {
        type: 'object',
        properties: {
            weave_slug: { type: 'string', description: 'Weave folder slug that contains the thread.' },
            thread_ulid: { type: 'string', description: 'Stable th_ ULID of the thread to rename.' },
            new_thread_slug: { type: 'string', description: 'New thread folder slug.' },
        },
        required: ['weave_slug', 'thread_ulid', 'new_thread_slug'],
    },
};
async function handle(root, args) {
    const result = await (0, thread_1.renameThread)({ weaveSlug: args['weave_slug'], threadUlid: args['thread_ulid'], newThreadSlug: args['new_thread_slug'] }, { getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root), loadDoc: dist_1.loadDoc, fs });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
